import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import MyLink from "../../components/myLink";
import EMTLevel from "../../components/emtLevel";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul>
    <h3 id="overview">
      Overview:
    </h3>
    <li>
      In accordance with M.G.L c. 111C, S18, the following guidelines may be
      followed to restrain a patient only when the patient presents an
      immediate or serious threat of bodily harm to him/herself or others.
    </li>
        <li>
  Adults (or emancipated minors as defined in A/R 5-610) who are
  competent with the functional capacity to understand the nature and
  effects of their actions and/or decisions have the right to refuse
  treatment and/or transport. Do not restraint these individuals.
        </li>
  </ul>
  <ol style={{
        padding: '0 1rem'
      }}>
    <h3 id="procedures" style={{
          margin: 0,
          padding: '0.2rem 0'
        }}>
    Procedures:
    </h3>
    <li>
      Follow
      <MyLink to="/sections/2/2.4-behavioral-emergencies" mdxType="MyLink">2.4 Behaviorial Emergencies</MyLink>
    </li>
    <li>
      Use the least restrictive method that assures the safety of the patient and other
    </li>
    <li>
      Use only soft restraints (leather restraints only if made with soft padding inside).
    </li>
    <li>
      Remind law enforcement that for ambulance transport, patients who are handcuffed must have handcuffs in front (not behind) or to the stretcher and that the key must be readily available for removal; if needed.
    </li>
    <li>
      Apply restraints in a way that allows for airway, breathing and circulation assessment.
    </li>
    <li>
      Never restrain a patient in a prone position or use equipment that forms a "sandwich" around the patient.
    </li>
    <li>
      Have a minimum of four (4) trained personnnel coordinate the restraint effort and consider involving parents if patient is a child.
    </li>
    <li>
      Secure the patient so that major sets of muscle groups ncannot be used together, restraining the lower extremities to the stretcher first around the ankles and across the thighs with soft restraints and stretcher straps.
    </li>
    <li>
      Restraint the patient's torso and upper extremities with one arm up and one down with soft restraints and stretcher straps; do not impair circulation.
    </li>
    <li>
      Consider cervical-spine immobilization to minimize violent head/body movements.
    </li>
    <li>
      Pad under patient's head to prevent self-harm.
    </li>
    <li>
      Secure backboard or scoop stretcher (if used) to ambulance stretcher.
    </li>
    <li>
      Transport OB patients in a semi-reclining or left lateral position.
    </li>
    <li>
      Monitor/record vitals signs every 5 minutes, ensuring patient's airway remains clear.
    </li>
    <li>
      Consider placing a non-rebreather mask (use only at 15lpm) or a face mask (NOT a P100/N95) on the spitting patient's face.
    </li>
    <li>
      Unless necessary for patient treatment, do not remove restraints until care is transferred at the receiving facility or condition has changed to necessitate removal.
    </li>
    <li>
      Notify the receiving facility and tell them that the patient is restrained
    </li>
    <li>
      Document restraint use details in the patient care report, including:
    </li>
    <ol>
      <li>Reason for restraint use.</li>
      <li>Time of application.</li>
      <li>Type(s) of restraints used, in addition to cot straps.</li>
      <li>Patient position.</li>
      <li>Neurovascular evaluation of extremities.</li>
      <li>Issues encountered during transport.</li>
      <li>Other treatment rendered.</li>
      <li>Police and/or other agency assistance.</li>
    </ol>
  </ol>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  Follow above protocols
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  Follow above protocols
    </EMTLevel>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      